import actions from './actions';

const initState = {
  loading: false,
  message: null,
  buttonLoading: false,
  error: null,
  cphResponseData: {},
  cphDetailResponseData:{},
  totalData: null,
  show: false
};


export default function authReducer(state = initState, action) {
  switch (action.type) {

    case actions.GET_CPH_DATA:
      return {
        ...state,
        loading: true,
      };
    case actions.GET_CPH_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        cphResponseData: action.payload.data,
        totalData: action.payload.totalData
      };
    case actions.GET_CPH_DATA_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

      case actions.GET_CPHDETAIL_DATA:
        // //console.log(action.payload);
        return {
          ...state,
          loading: true,
        };
      case actions.GET_CPHDETAIL_DATA_SUCCESS:
        return {
          ...state,
          loading: false,
          cphDetailResponseData: action.payload.data,
          totalData: action.payload.totalData
        };
      case actions.GET_CPHDETAIL_DATA_FAILED:
        return {
          ...state,
          loading: false,
          error: action.payload.error,
        };
  
    default:
      return state;
  }

}
